import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Organization } from '../user-account/user-organization.model';
import { BaseBackendService } from './base-backend.service';
import { SsoAuthService } from './sso.service';

@Injectable({
    providedIn: 'root',
})
export class MyOrganizationsService extends BaseBackendService<Organization> {
    constructor(
        http: HttpClient,
        protected override authService: AuthService,
        ssoService: SsoAuthService
    ) {
        super(http, authService, Organization, 'myorganizations', ssoService);
    }
}
